import React from "react";
import { ourServices } from "../lib/servicesContent";

export default function DesktopServices() {
  return (
    <section className="hidden w-full p-10 sm:p-14 md:p-20 lg:block lg:p-32 xl:p-36">
      <h2 className="mb-12 text-center text-3xl font-bold text-primaryColor lg:text-left xl:mb-16">
        {ourServices?.title}
      </h2>
      <ul className="w-full">
        {ourServices?.content?.map((feature, index) => {
          return (
            <li key={index} className="mb-20 flex w-full items-center xl:mb-24">
              {index % 2 === 0 && (
                <h2 className="w-1/4 p-8 text-center text-2xl font-bold text-primaryColor xl:text-3xl">
                  {feature?.title}
                </h2>
              )}
              <div className="w-3/4 rounded-3xl bg-slate-300 p-10 xl:p-12">
                <p className="mb-12 text-lg xl:mb-12 xl:text-xl">
                  {feature?.body}
                </p>
                <ul className="flex w-full flex-wrap justify-evenly gap-2">
                  {feature?.subContent?.map((subFeature, index) => {
                    return (
                      <li
                        key={index}
                        className={`${feature?.subContent?.length % 3 === 0 ? "w-1/4" : "w-1/3"} rounded-3xl bg-white p-4 xl:p-6`}
                      >
                        <p className="text-base xl:text-lg">{subFeature}</p>
                      </li>
                    );
                  })}
                </ul>
              </div>
              {index % 2 !== 0 && (
                <h2 className="w-1/4 p-8 text-center text-2xl font-bold text-primaryColor xl:text-3xl">
                  {feature.title}
                </h2>
              )}
            </li>
          );
        })}
      </ul>
    </section>
  );
}
